// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import './NotificationDateGroup.css';

export interface NotificationDateGroupProps {
  label: string;
  className?: string;
}

export function NotificationDateGroup({
  label,
  className = '',
}: NotificationDateGroupProps) {
  const classes = ['fin-notif-date-group', className].filter(Boolean).join(' ');

  return <div className={classes}>{label}</div>;
}
